import React from "react";
import { styled } from "styled-components";
import ColorField from "../ColorField";

const Container = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Separator = styled.hr`
  width: 100%;
`;

export default function TertiaryThemeForm() {
  return (
    <Container>
      <h2>Tertiary</h2>
      <ColorField
        label="Background"
        name="tertiary.color"
        info="Outlet, orders listing background"
        infoId="tertiaryColor"
      />
      <Separator />
      <h3>Content</h3>
      <ColorField label="Default" name="tertiary.content.default" />
      <ColorField label="Danger" name="tertiary.content.danger" />
      <Separator />
      <h3>Surfaces</h3>
      <h4>Default</h4>
      <ColorField
        label="Background"
        name="tertiary.surfaces.default.color"
        info="Quantity modifier background"
        infoId="tertiarySurfacesDefaultColor"
      />
      <ColorField
        label="Content  - Default"
        name="tertiary.surfaces.default.content.default"
      />
      <ColorField
        label="Content  - Alternative 1"
        name="tertiary.surfaces.default.content.alt_1"
        info="Order Card - Order Time"
        infoId="tertiarySurfacesDefaultContentAlt1"
      />
      <ColorField
        label="Content  - Alternative 2"
        name="tertiary.surfaces.default.content.alt_2"
        info="Outlet card active order type"
        infoId="tertiarySurfacesDefaultContentAlt2"
      />
      <h4>Alternative 1</h4>
      <ColorField label="Background" name="tertiary.surfaces.alt_1.color" />
      <ColorField
        label="Content  - Default"
        name="tertiary.surfaces.alt_1.content.default"
      />
    </Container>
  );
}
